<compartido-ficha [configuracion]="configFicha">
  <compartido-tabla-asincrona
    #tabla
    class="tabla {{ responsiveService.claseCSS$ | async }}"
    [dataSource]="dataSource"
    [configuracion]="configTabla"
    (clickAccion)="recogerOrden$($event.fila['id'])"
    (clickBoton)="!this.cargando() && abrirEscaner$()"
  ></compartido-tabla-asincrona>

  <div class="resumen">
    <p>
      Recogidas Hoy:
      <span *ngIf="!cargando()">{{ recogidas() }}</span>
      <mat-spinner
        *ngIf="cargando()"
        diameter="13"
        class="cargando"
      ></mat-spinner>
    </p>
  </div>
</compartido-ficha>
